import { useSelector } from 'react-redux'
import { Navigate } from 'react-router-dom'

import { selectIsAuth } from '../reducers/userDataReducer'
// import { getAuthRedirectUrl } from './Auth/utils'

export default function Protect({ component: Component }) {
  const isAuthenticated = useSelector(selectIsAuth)

  if (!isAuthenticated) {
    return <Navigate to={'/login'} replace />
  }

  return <Component />
}
